import React from 'react';

const Popup = ({ isOpen, onClose, message, title = 'SportsBid Arena', type = 'info' }) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'bi-check-circle-fill text-success';
      case 'error':
        return 'bi-exclamation-triangle-fill text-danger';
      case 'warning':
        return 'bi-exclamation-circle-fill text-warning';
      default:
        return 'bi-info-circle-fill text-info';
    }
  };

  const getAlertClass = () => {
    switch (type) {
      case 'success':
        return 'alert-success';
      case 'error':
        return 'alert-danger';
      case 'warning':
        return 'alert-warning';
      default:
        return 'alert-info';
    }
  };

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
      <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className={`modal-header ${getAlertClass()}`}>
            <div className="d-flex align-items-center">
              <i className={`bi ${getIcon()} me-3 fs-2`}></i>
              <h5 className="modal-title mb-0">{title}</h5>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body text-center">
            <p className="mb-0">{message}</p>
          </div>
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              className="btn btn-primary"
              onClick={onClose}
            >
              <i className="bi bi-check-circle me-2"></i>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;